import store from '@/store'
import config from '@/utils/config'
import i18n from '@/i18n'

/**
 * Callback executed on any request success
 * @param {*} response  Obtained from service
 * @return {*}  Response
 */
const onResponse = (response) => {
  store.dispatch('errors/empty')
  return response
}

/**
 * Callback executed on any failed request
 * @param {*} error Obtained from service
 * @return {Promise} Promise rejection
 */
const onError = (error) => {
  let msg = ''
  let desc = 'login.sesion.' + error.response.data.description
  if (isJCyL()) {
    desc += '_jcyl'
  }
  msg = translateError(desc)
  if (desc === 'login.sesion.blocked_user' || desc === 'login.sesion.user_pass_invalid_jcyl') {
    store.dispatch('errors/addServerError', { msg: msg, html: true })
  } else {
    store.dispatch('errors/addServerError', { msg: msg })
  }
  return Promise.reject(error)
}

/**
 * Translates error description key
 * @param {*} desc  Error description key
 * @return {*} Translated error
 */
function translateError(desc) {
  if (desc === 'login.sesion.inactive_user' || desc === 'login.sesion.inactive_user_jcyl' || desc === 'login.sesion.blocked_user_jcyl') {
    return i18n.t(desc) + config.invalidUserMail
  } else {
    return i18n.t(desc)
  }
}

/**
 * Returns whether is JCyL promoter
 * @return {boolean}
 */
function isJCyL() {
  return config.promoterCode === 9905
}

export default {
  onResponse,
  onError
}
